<template>
  <div class="page">
    <div class="form-group">
      <base-input
        inputType="text"
        labelText="Genel Çarpan Değeri"
        id="multiplexer"
        placeholder="Site Genelindeki Çarpan Değeri"
        v-model="multiplixerValue"
        :withIcon="false"
        :noSpace="true"
        :noComma="true"
      />
      <base-button
        @click="updateMultiplexerValue"
        class="button-update"
        :class="{ disabled: isMultiplexerClicked }"
        >Çarpan Değerini Güncelle</base-button
      >
    </div>
    <div class="form-group mw-320">
      <base-input
        inputType="number"
        labelText="Mevcut Limit Değerini Güncelle (Overall+BES)"
        id="overall"
        placeholder="Site Genelindeki Overall Değeri"
        v-model="overallValue"
        :withIcon="false"
      />
      <base-button
        @click="updateOverallLimits"
        class="button-update"
        :class="{ disabled: isUpdateOverallClicked }"
        >Mevcut Limit Değerini Güncelle</base-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { BaseInput, BaseButton } from "@/components";
export default {
  name: "ParametersPage",
  components: { BaseInput, BaseButton },
  data() {
    return {
      multiplixerValue: "",
      overallValue: "",
      isMultiplexerClicked: false,
      isUpdateOverallClicked: false,
    };
  },
  methods: {
    ...mapActions([
      "getSiteSettings",
      "updateGlobalMultiplexer",
      "monthlyGetOverallLimit",
      "updateOverall",
    ]),
    getMultiplexerValue() {
      this.getSiteSettings().then((response) => {
        this.multiplixerValue = response.costMultiplexer;
      });
    },
    getOverallLimitOnLoad() {
      this.monthlyGetOverallLimit().then((response) => {
        if (response.status === 200) {
          this.overallValue = response.data.overallLimit;
        }
      });
    },
    updateMultiplexerValue() {
      this.isMultiplexerClicked = true;
      this.updateGlobalMultiplexer({ Value: this.multiplixerValue }).then(
        (response) => {
          if (response.error) {
            this.$toast.error(response.message);
          } else {
            this.$toast.success("Çarpan değeriniz güncellenmiştir.");
          }
          this.isMultiplexerClicked = false;
        }
      );
    },
    updateOverallLimits() {
      this.isUpdateOverallClicked = true;
      this.updateOverall({ Value: this.overallValue }).then((response) => {
        if (response.error) {
          this.$toast.error(response.message);
        } else {
          this.getOverallLimitOnLoad();
          this.$toast.success("Overall değeriniz güncellenmiştir.");
        }
        this.isUpdateOverallClicked = false;
      });
    },
  },
  mounted() {
    this.getOverallLimitOnLoad();
    this.getMultiplexerValue();
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .form-group {
    max-width: 300px;
    border: 1px solid #ccc;
    padding: 10px;
    width: 100%;
    .button-update {
      margin-top: 20px;
      &.disabled {
        pointer-events: none;
      }
    }
    &.mw-320 {
      max-width: 320px;
    }
  }
}
</style>
